<template>
  <div>
    <!-- Update submission details dialog -->
    <edit-submission-details
    :visible="edit_submission_details_dialog.show"
    :submission="edit_submission_details_dialog.submission"
    :value="application"
    :enableIncome="edit_submission_details_dialog.enable_income"
    @onCancel = "edit_submission_details_dialog.show = false"
    >
    </edit-submission-details>
    <!-- Update submission details dialog -->
    <upload-document-details
    :visible="upload_documents_details_dialog.show"
    :submission="upload_documents_details_dialog.submission"
    :documents="upload_documents_details_dialog.documents"
    :value="application"
    @onCancel = "upload_documents_details_dialog.show = false;
                $refs.uploadDocumentDetails.resultMessage = null;
                $refs.uploadDocumentDetails.isSubmitted = false;"
    ref="uploadDocumentDetails"
    >
    </upload-document-details>
    <!-- Submission Summary Dialog-->
    <submission-summary
      :submission="submission_summary.submission"
      :active="submission_summary.visible"
      @onCancel = "submission_summary.visible = false"
    >
    </submission-summary>
    <group-card title="Submissions" icon="history">
      <template slot="actions" v-if="showNewSubmmissionBtn">
        <md-button
          v-if="!hasFinalizedSubmission || userHasRole('super-admin')"
          class="md-icon-button md-primary md-simple new-app-button"
          @click="toggleSubmitToLenderForm(true)"
        >
          <md-icon id="new-app-icon">note_add</md-icon>
          New Submission
        </md-button>
      </template>
      <table class="data-table wide">
        <thead>
          <tr>
            <th><code>Status</code></th>
            <th><code>Product</code></th>
            <th><code>NAF</code></th>
            <th><code>Rate</code></th>
            <th><code>Term</code></th>
            <th><code>Fees</code></th>
            <th><code>Finalized</code></th>
            <th><code>Method</code></th>
            <th><code>Actions</code></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="submission of application.loan.submission.previous" :key="submission.id" :class="getActiveClass(submission.id)">
            <td>{{ submission.status }}</td>
            <td>
              {{ submission.product.lender_name }}:
              {{ submission.product.product_name }}
            </td>
            <td>{{ submission.naf | currency }}</td>
            <td>{{ submission.rate | percentage(4, false) }}</td>
            <td>{{ submission.term }}</td>
            <td>{{ submission.document_origination_fee | currency }}</td>
            <td>
              <span v-if="isActiveSubmission(submission.id) && hasFinalizedSubmission">
                <md-tooltip md-direction="top">Finalized Submission</md-tooltip>
                <md-icon class="md-icon md-primary">check_circle</md-icon>
              </span>
              <span v-else-if="isActiveSubmission(submission.id) && !hasFinalizedSubmission">
                <md-tooltip md-direction="top">Not Finalized</md-tooltip>
                <md-icon class="md-icon md-primary orange-icon">warning</md-icon>
              </span>
            </td>
            <td>{{ submission.submission_method }}</td>
            <td>
              <md-button v-if="needsDocUpload(submission.product.lender_name) && !shouldHide"
                        @click="openEditSubmissionUploadDocumentsDialog(submission)" class="md-primary md-simple"
                        :disabled="isSaving">
                <md-tooltip md-direction="left">Upload {{ submission.product.lender_name }} Required Documents</md-tooltip>
                Upload Documents
              </md-button>
              <span v-if="!hasFinalizedSubmission || isComplianceFailStatus">
                <md-button @click="openEditSubmissionDetailsDialog(submission)" class="md-primary md-simple"
                            :disabled="isSaving">
                <md-tooltip md-direction="left">Update Fees</md-tooltip>
                Update Fees
              </md-button>
              <md-menu md-size="medium" md-direction="bottom-start" md-align-trigger class="">
                <md-button v-if="needPepperAction(submission)" md-menu-trigger
                  class="md-primary md-simple" :disabled="application_status.id === null">
                  Actions
                  <md-icon>arrow_drop_down</md-icon>
                </md-button>
                <md-menu-content class="action-menu">
                  <md-menu-item @click="submitPepperV3ProcessToLender(submission, 'credit-doc-request')">
                    CreditDocReview Request
                  </md-menu-item>
                  <md-menu-item @click="validateAndSubmitPepperProcess(submission, 'resubmit-application')">
                    Resubmit Application
                  </md-menu-item>
                  <md-menu-item @click="submitPepperV3ProcessToLender(submission, 'generate-document-request')">
                    Generate Document Request
                  </md-menu-item>
                  <md-menu-item @click="submitPepperV3ProcessToLender(submission, 'e-sign-request')">
                    Electronic Signature Request
                  </md-menu-item>
                  <md-menu-item @click="submitPepperV3ProcessToLender(submission, 'initiateSettlement-request')">
                    initiateSettlement Request
                  </md-menu-item>
                  <md-menu-item @click="validateAndSubmitPepperProcess(submission, 'biometrics-request')">
                    Biometrics Request
                  </md-menu-item>
                </md-menu-content>
              </md-menu>
              <md-button
                v-if="!hasFinalizedSubmission || userHasRole('super-admin')"
                @click="settleApplication(submission, 'Approved')"
                class="md-raised md-primary"
                :disabled="isSaving"
              >
                  <md-tooltip md-direction="left">Prepare Settlement</md-tooltip>
                  Prepare Settlement
              </md-button>
              </span>
              <span v-else-if="isActiveSubmission(submission.id) && hasFinalizedSubmission">
                <md-button v-if="userHasPermission('update finalized-submission')"
                            @click="openEditSubmissionDetailsDialog(submission)" class="md-primary md-simple"
                            :disabled="isSaving">
                    <md-tooltip md-direction="left">Update Fees</md-tooltip>
                    Update Fees
                </md-button>
                <md-button @click="openDetailsDialog(submission)" class="md-primary md-simple">
                <md-tooltip md-direction="top">View Submission Details</md-tooltip>
                View
              </md-button>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </group-card>
    <md-dialog-alert
      :md-active.sync="error_dialog.show"
      :md-title="error_dialog.title"
      :md-content="error_dialog.content" />
    <div>
      <md-dialog :md-active.sync="pepperv3.showDialog">
        <h5 :class="pepperv3.alert" v-if="pepperv3.validationError" v-html="pepperv3.resultMessage"></h5>
        <div class="dialogWrapper">
          <md-dialog-title>Broker Consent</md-dialog-title>
          <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-size-100" >
                By proceeding with this application, you confirm that you have obtained the customer’s consent to receiving and signing their loan documents electronically.
              </div>
              <div class="md-layout-item md-small-size-100 md-size-100" >
                Request Type
              </div>
              <md-radio class="md-layout-item" v-model="pepperv3.requestType" :value="'Request'">Request</md-radio>
              <md-radio class="md-layout-item" v-model="pepperv3.requestType" :value="'Resend'">Resend</md-radio>
              <md-radio class="md-layout-item" v-model="pepperv3.requestType" :value="'Cancel'">Cancel</md-radio>
          </div>
        </div>
        <md-dialog-actions>
          <loading-icon-text-button class="md-primary"  :loading="pepperv3.loading_biometrics" @click="submitPepperV3ProcessToLender(submission, processName)">Proceed</loading-icon-text-button>
          <md-button class="md-primary" @click="closeDialog">Close</md-button>
        </md-dialog-actions>
      </md-dialog>
    </div>
    <!-- nccp Popup -->
    <applicant-NCCP-modal
        :visible="showNccpPopup"
        @nccp-object-created="processResubmitApplication"
        @closeNccpPopup="onCloseNccpPopup"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import filters from "@/components/utils/filters";
import ValidatedInputs from "@/components/ValidatedInput";
import GroupCard from "@/components/Cards/GroupCard";
import WaitingDialog from "@/components/Dialogs/WaitingDialog";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import EditSubmissionDetails from "./EditSubmissionDetails";
import UploadDocumentDetails from "./UploadDocumentDetails";
import AlertDialog from "../Dialogs/AlertDialog";
import SubmissionSummary from "../ApplicationSummary/SubmissionSummary";
import ApplicantNCCPModal from './ApplicantNccpModal.vue';

export default {
  components: {
    SubmissionSummary,
    EditSubmissionDetails,
    LoadingIconTextButton,
    ...ValidatedInputs,
    GroupCard,
    UploadDocumentDetails,
    ApplicantNCCPModal,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    // below prop is used to hide necessary buttons in order to use this component in settlement_form page.
    shouldHide: {
      type: Boolean,
      default: false,
    },
    suitabilityAssessment: {
        type: Boolean,
        default: false,
        required: true,
    }
  },
  data() {
    return {
      pepperv3: {
        alert: null,
        resultMessage: '',
        requestType: 'Request',
        loading_biometrics: false,
        showDialog: false,
        validationError: false,
      },
      edit_submission_dialog: {
        show: false,
        submission: null,
        lender_name: null,
        product_name: null,
        status: null,
        application_status: null,
        response_message: null,
        allows_settlement: null,
      },
      error_dialog: {
        show: false,
        title: "",
        content: "",
      },
      submission: null,
      processName: null,
      showNccpPopup: false,
      processing_settlment: false,
      isSaving: false,
      edit_submission_details_dialog:{
        show: false,
        submission: false,
        enable_income: true,
      },
      isMoneyThree: false,
      upload_documents_dialog: {
        show: false,
        submission: null,
        lender_name: null,
        product_name: null,
        status: null,
        application_status: null,
        response_message: null,
        allows_settlement: null,
        documents: null,
      },
      upload_documents_details_dialog: {
        show: false,
        submission: false,
        documents: false,
      },
      submission_summary: {
        submission: null,
        visible: false,
      },
    };
  },
  mounted() {
    this.getDocuments();
  },
  computed: {
    // standard Upload of options from store
    ...mapGetters([
      "application",
      "application_status",
      "properties",
      "productLenders",
      "products",
      "uploadedDocuments",
      "userHasPermission",
      "userHasRole",
      "security",
    ]),

    showNewSubmmissionBtn() {
        if (!this.shouldHide && !this.application.loan.is_commercial && this.suitabilityAssessment) {
            return true;
        } else if (!this.shouldHide && this.application.loan.is_commercial) {
            return true;
        }
        return false;
    },

    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    application: {
      get() {
        return this.value;
      },
      set(application) {
        this.$emit("input", application);
      },
    },

    edit_submission_dialog_allows_settlement() {
      if (this.edit_submission_dialog.submission) {
        let status = this.edit_submission_dialog.status;
        let properties = this.properties.submission_status[status];
        return properties.allows_settlement;
      } else {
        return false;
      }
    },
    hasActiveSubmission() {
      return !!this.application.loan.submission.active.id;
    },
    hasFinalizedSubmission() {
      return this.application.loan.submission.active.is_settled;
    },
    isComplianceFailStatus() {
      let status = this.application.loan.status.status === "Fail";
      let stage = this.application.loan.status.stage === "Compliance";
      return status && stage;
    },
  },
  methods: {
    // make all filters available as methods
    ...filters,
    openEditSubmissionDetailsDialog(submission) {
      this.edit_submission_dialog.show = false;
      this.edit_submission_details_dialog.show = false;
      this.edit_submission_details_dialog.submission = submission;
      this.edit_submission_details_dialog.show = true;
      this.edit_submission_details_dialog.enable_income = !this.isComplianceFailStatus;
    },
    async submitPepperV3ProcessToLender(submission, processName) {
      const currentProcessName = processName.replaceAll("-", " ");
      try {
        let payload = {
          submission_id: submission.id,
          application_id: this.application.loan.id,
          processName,
        };
        const isWaitingDialogRequired = !['biometrics-request'].includes(processName);
        if (isWaitingDialogRequired) {
          this.$modal.show(WaitingDialog, {
            title: `Submitting application for ${currentProcessName}...`,
            message:
              "Please wait while we process your application.",
          });
          if (processName === "resubmit-application" &&
                Object.keys(applicantNCCP).length !== 0 && applicantNCCP.constructor === Object
          ) {
            payload.NCCP = applicantNCCP;
          }
        } else {
          this.pepperv3.loading_biometrics = true;
          payload.requestType = this.pepperv3.requestType;
        }
        const status = await this.$store.dispatch(
          "pepper_v3_check_status_submit_to_lender",
          payload
        );
        if (status && status.submitted === true) {
           //close an existing modal if it is open
          if (this.$modal.submit) {
            this.$modal.submit();
          }
          if (processName === 'initiateSettlement-request') {
            const data_api = JSON.parse(status.data || "{}");
            if (data_api?.commission) {
                const incomes = {
                    "lender_commission": {
                        "amount": data_api.commission,
                        "include_in_naf": false
                    },
                };
                await this.$store.dispatch("saveBrokerIncomes", {
                        incomes: incomes,
                        brokerSettlement: this.application,
                    }
                )
            }
            await this.showPricingPlan(data_api);
          } else {
            this.showDialogNotification(
                `The ${currentProcessName} process completed successfully`,
                `Application Process Status`
            );
          }
        } else {
          const errorMessage = this.handleSubmitError(status)
          if (processName === 'biometrics-request') {
            this.pepperv3.validationError = true;
            this.pepperv3.alert = 'proceed_error';
            this.pepperv3.resultMessage = errorMessage;
            this.pepperv3.loading_biometrics = false;
          } else {
            this.showDialogNotification(
              `The ${currentProcessName} process cannot be submitted for some reasons - \n` + errorMessage,
              `Application Process Status.`
            );
          }
        }
      } catch (error) {
        if (this.$modal.submit) {
          this.$modal.submit();
        }
        this.showDialogNotification(
          `The ${currentProcessName} process cannot be submitted for some reasons - \n` + error,
          `Application Process Status.`
        );
      }
    },
    async showPricingPlan(response)
    {
      //if there is an existing modal open close it
      if (this.$modal.submit) {
          this.$modal.submit();
      }
      const message = `<ul>
            <li><strong>Interest Rate:</strong> ${response.interestRate}</li>
            <li><strong>Commission:</strong> ${response.commission}</li>
            <li><strong>Net Amount Financed:</strong> ${response.netAmountFinanced}</li>
            <li><strong>Standard Repayment:</strong> ${response.standardRepayment}</li>
            <li><strong>Repayment:</strong> ${response.repayment}</li>
            <li><strong>Disclaimer:</strong> ${response.disclaimer}</li>
        </ul>
    `;
      return this.showDialogNotification(message, "Pricing Plan");
    },
    processResubmitApplication(applicantNCCP) {
      this.submitPepperV3ProcessToLender(this.submission, this.processName, applicantNCCP);
    },
    onCloseNccpPopup() {
      this.showNccpPopup = false;
    },
    openEditSubmissionDialog(submission, status = null){
      this.edit_submission_dialog.show = false;
      this.edit_submission_details_dialog.show = false;
      this.edit_submission_dialog.submission = submission;
      this.edit_submission_dialog.lender_name = submission.product.lender_name;
      this.edit_submission_dialog.product_name = submission.product.product_name;
      this.edit_submission_dialog.status = status ?? submission.status;
      this.edit_submission_dialog.application_status = { ...this.application.loan.status };
      this.edit_submission_dialog.response_message = submission.response_message;
      this.edit_submission_dialog.allows_settlement = submission.allows_settlement;
      this.edit_submission_dialog.show = !status;
    },
    onEditSubmissionDialogClose() {
      this.edit_submission_dialog.show = false;
      this.edit_submission_dialog.submission = null;
    },
    closeDialog() {
      this.pepperv3.showDialog = false;
      this.pepperv3.validationError = false;
    },
    async onEditSubmissionDialogSave() {
      this.edit_submission_dialog.submission.lender_name = this.edit_submission_dialog.lender_name;
      this.edit_submission_dialog.submission.product_name =
        this.edit_submission_dialog.product_name;
      this.edit_submission_dialog.submission.status = this.edit_submission_dialog.status;
      this.edit_submission_dialog.submission.response_message =
        this.edit_submission_dialog.response_message;
      this.edit_submission_dialog.submission.allows_settlement =
        this.edit_submission_dialog.allows_settlement;

      let status = await this.$store.dispatch("save_application", this.application);

      this.edit_submission_dialog.show = false;
    },
    async settleApplication(submission, settlementType) {
      //Referrer is required before settlement
      /* if (!this.application.owners[1].user_id) {
          this.$modal.show(AlertDialog, {
            title: "Referrer Required",
            message: 'Please enter the referrer for this application before settlement.'
          })
        return;
      } */

      //Supplier Name is required before settlement (Except Unsecured and Cashflow Security)
      /* if (this.security.loan_asset_type_id != 'C'
        && this.security.loan_asset_type_id != 'P') {
        if (!this.security.supplier_name) {
          this.$modal.show(AlertDialog, {
            title: "Supplier Name Required",
            message: 'Please enter the supplier for this application before settlement.'
          })
          return;
        }
      } */

      this.openEditSubmissionDialog(submission, settlementType);
      this.$modal.show(WaitingDialog, {
        title: "Submitting Application...",
        message: "Please wait whilst we are submitting the application.",
      });
      this.onEditSubmissionDialogSettle();
    },
    async validateAndSubmitPepperProcess(submission, processName) {
      if (processName === 'biometrics-request') {
        this.submission = submission;
        this.processName = processName;
        this.pepperv3.showDialog = true;
      } else if (processName === 'resubmit-application') {
        this.submission = submission;
        this.processName = processName;
        await this.saveApplication();
        this.showNccpPopup = true;
      } else {
        await this.submitPepperV3ProcessToLender(submission, processName)
      }
    },
    async saveApplication() {
      try {
        this.$modal.show(WaitingDialog, {
          title: "Saving Application...",
          message: "Please wait whilst we are saving the application.",
        });

        // save the entire application
        await this.$store.dispatch("save_application", this.application);
        if (this.$modal.submit) {
          this.$modal.submit();
        }
      } catch (error) {
        if (this.$modal.submit) {
          this.$modal.submit();
        }
        this.showDialog(
          "Failed to save application.",
          `The application cannot be saved for some reasons - \n` +
          error?.response?.data
        );
        throw new Error("Failed to save application - " + error?.response?.data);
      }
    },
    async onEditSubmissionDialogSettle() {
      this.isSaving = true;
      this.edit_submission_dialog.submission.lender_name = this.edit_submission_dialog.lender_name;
      this.edit_submission_dialog.submission.product_name =
        this.edit_submission_dialog.product_name;
      this.edit_submission_dialog.submission.status = this.edit_submission_dialog.status;
      this.edit_submission_dialog.submission.response_message =
        this.edit_submission_dialog.response_message;
      this.edit_submission_dialog.submission.allows_settlement =
        this.edit_submission_dialog.allows_settlement;

      let status = await this.$store.dispatch("save_application", this.application);

      // update app status
      if (this.edit_submission_dialog.status === "Submitted" || this.edit_submission_dialog.status === "Conditionally Approved" || this.edit_submission_dialog.status === "Approved") {
        let status = "";
        switch (this.edit_submission_dialog.status) {
          case 'Submitted':
            status = "Submitted";
            break;
          case 'Conditionally Approved':
            status = "Approved - Conditional";
            break;
          case 'Approved':
            status = "Approved";
            break;
        }
        try {
          await this.$store.dispatch('update_application_status', {
            application_id: this.application.loan.id,
            stage: "Broker",
            status: status,
            reason: "Other",
            comment: "",
          });
        } catch (error) {
          console.log(error);
          this.$modal.show(AlertDialog, {
            title: "Error",
            message: 'Error changing the status to: ' + this.edit_submission_dialog.status
          })
        }
      }

      this.edit_submission_dialog.show = false;
      this.createNewBrokerSettlementRequest();
    },
    async createNewBrokerSettlementRequest() {
      let result = await axios.post(
        `/api/v1/application/${this.application.loan.id}/settlement/${this.edit_submission_dialog.submission.id}`,
        this.application
      );
      if (result) {
        const self = this;
        // keeping this check means if this whole component is being loaded in settlement_form page,
        // there's no need to router push it again. since it'll re-route it at same page.
        if (!this.shouldHide) {
          this.showDialogNotification("Taking you to Settlement Request page.", "Application Saved.");
          setTimeout(function () {
            self.$router.push(`settlement_form`);
          }, 3000);
        } else {
          if (this.$modal.submit) {
            this.$modal.submit();
          }
          this.$parent.getExistingSettlement()
        }
      } else {
        this.showDialogNotification(result, "Error");
      }
    },
    showDialogNotification(message, title) {
      if (this.$modal.submit) {
        this.$modal.submit();
      }

      this.isSaving = false;
      this.error_dialog.title = title;
      this.error_dialog.content = message;
      this.error_dialog.show = true;
    },
    handleSubmitError(status) {
      let errorMessage = "";
      if (status.data) {
        const errorData = JSON.parse(status.data);
        if (Array.isArray(errorData)) {
          Object.values(errorData).forEach((element) => {
            const path_hint = element.field;
            if (path_hint != undefined) {
              const fieldArr = path_hint.split(".");
              const field = filters.capitalize(fieldArr[fieldArr.length - 1]);
              errorMessage += `<p>${field} ${element.message
                .toLowerCase()
                .trim()}</p>`;
            } else {
              errorMessage += `<p>${element.message}</p>`;
            }
          });
        } else {
          const path_hint = errorData.field;
          if (path_hint != undefined) {
            const fieldArr = path_hint.split(".");
            const field = filters.capitalize(fieldArr[fieldArr.length - 1]);
            errorMessage += `<p>${field} ${errorData.message
              .toLowerCase()
              .trim()}</p>`;
          } else {
            errorMessage += `<p>${errorData.message}</p>`;
          }
        }
      }

      if (errorMessage === "") {
        errorMessage = JSON.stringify(status);
      }
      return errorMessage;
    },
    openEditSubmissionUploadDocumentsDialog(submission) {
      this.upload_documents_dialog.show = false;
      this.upload_documents_details_dialog.show = false;
      this.upload_documents_details_dialog.submission = submission;
      this.upload_documents_details_dialog.documents = this.uploadedDocuments;
      this.upload_documents_details_dialog.show = true;
    },
    async getDocuments(){
      let response = await this.$store.dispatch('fetch_doc_uploaded', {application_id: this.$route.params.id, showDeleted: false});
    },
    getActiveClass(id) {
      return this.isActiveSubmission(id) ? 'active-submission' : '';
    },
    isActiveSubmission(id)
    {
      if (this.application.loan.submission.active.id && this.application.loan.submission.active.id == id) {
        return true;
      }
      return false;
    },
    needsDocUpload(lenderName) {
      let lenders = ['Pepper Asset Finance (Consumer)', 'Money3'];
      return lenders.includes(lenderName);
    },
    needPepperAction(submission) {
      const lenders = ['Pepper Asset Finance (Consumer)','Pepper Asset Finance (Commercial)'];
      const lenderName = submission.product.lender_name;
      // BAUU-559 hide the action menu until it is ready.
      return false;
      // return lenders.includes(lenderName) && submission.submission_via_api;
    },
    openDetailsDialog(submission)
    {
      this.submission_summary.submission = submission;
      this.submission_summary.visible = true;
    },
    toggleSubmitToLenderForm(value = true) {
      this.$store.dispatch("toggle_submit_to_lender_form", value);
    },
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
  async beforeCreate() {
    const params = {
      types: [
        'submission_status',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
  created() {
    if (this.application.loan.submission.previous.length > 0) {
      this.toggleSubmitToLenderForm(false);
    } else {
      this.toggleSubmitToLenderForm();
    }
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/md-custom/_ausloans-colors.scss";
.active-submission{
  background-color: $ausloans-green-light;
}
.orange-icon {
  color: $ausloans-orange !important;
}
</style>
